import { useState, useEffect } from "react";
import { MapPin } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useFb } from "../../utils/football";

const COUNTRIES = [
  "United Arab Emirates", "India", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman",
  "United Kingdom", "United States", "Canada", "Australia", "Pakistan", "Bangladesh",
  "Sri Lanka", "Nepal", "Egypt", "Morocco", "Nigeria", "South Africa", "Argentina",
  "Brazil", "France", "Spain", "Germany", "Portugal", "Italy", "Netherlands", "Belgium",
  "Mexico", "Japan", "South Korea", "Other",
];

/**
 * CountryModal (Tier 1 profiling) — country at signup. Auto-detects from IP via
 * ipapi.co, allows override, defaults UAE. Self-gates: shows only when the user
 * has seen the launch interstitial but has no country yet.
 */
export const CountryModal = () => {
  const { dbUser, setDbUser } = useAuth();
  const fb = useFb();
  const [country, setCountry] = useState("United Arab Emirates");
  const [saving, setSaving] = useState(false);

  const show = dbUser && dbUser.has_seen_football_launch && !dbUser.country;

  useEffect(() => {
    if (!show) return;
    let active = true;
    (async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        if (active && data?.country_name && COUNTRIES.includes(data.country_name)) {
          setCountry(data.country_name);
        }
      } catch { /* default UAE */ }
    })();
    return () => { active = false; };
  }, [show]);

  if (!show) return null;

  const save = async () => {
    setSaving(true);
    try { await fb.put("/users/profile", { country }); } catch {}
    setDbUser({ ...dbUser, country });
    setSaving(false);
  };

  return (
    <div className="football-theme fixed inset-0 z-[65] grid place-items-center bg-black/70 p-5" data-testid="country-modal">
      <div className="w-full max-w-sm rounded-2xl border border-border bg-card p-6">
        <MapPin size={28} className="wc-gold" />
        <h2 className="mt-3 text-xl font-extrabold">Where are you watching from?</h2>
        <p className="mt-1 text-sm text-muted-foreground">Helps us tailor leaderboards and your experience.</p>
        <select
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          className="mt-4 h-12 w-full rounded-xl border border-border bg-background px-3 text-sm outline-none focus:border-amber-400"
          data-testid="country-select"
        >
          {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <button
          onClick={save}
          disabled={saving}
          className="mt-4 w-full rounded-xl wc-bg-gold py-3 font-extrabold text-slate-900 disabled:opacity-60"
          data-testid="country-save"
        >
          {saving ? "Saving…" : "Continue"}
        </button>
      </div>
    </div>
  );
};

export default CountryModal;
